import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { MEDIA } from "../lib/media";
import { img } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login, register, settings } = useStore();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = mode === "login" ? await login(f.email, f.password) : await register(f);
      toast.success(`Welcome${u.name ? ", " + u.name.split(" ")[0] : ""}.`);
      nav(u.role === "customer" ? "/account" : "/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-[80vh]">
      <div className="hidden lg:block relative">
        <img src={MEDIA.mist} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/40" />
        <div className="absolute bottom-12 left-12 text-ivory">{settings.logo_dark ? <img src={img(settings.logo_dark)} alt="the IAH" className="h-20 w-auto" /> : <div className="serif text-5xl tracking-[0.12em]">IAH</div>}<p className="text-ivory/70 mt-2">Nature. Purity. Essence.</p></div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          <h1 className="serif text-4xl mb-2">{mode === "login" ? "Welcome Back" : "Create Account"}</h1>
          <p className="text-forest/55 text-sm mb-8">{mode === "login" ? "Sign in to your ritual." : "Join the IAH community."}</p>
          <form onSubmit={submit} className="space-y-5">
            {mode === "register" && <input className="input-line" placeholder="Full name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="auth-name" />}
            <input className="input-line" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="auth-email" />
            {mode === "register" && <input className="input-line" placeholder="Phone (optional)" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="auth-phone" />}
            <input className="input-line" type="password" placeholder="Password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="auth-password" />
            <button className="btn-primary w-full" disabled={loading} data-testid="auth-submit">{loading ? "Please wait…" : (mode === "login" ? "Sign In" : "Create Account")}</button>
          </form>
          <p className="text-sm text-forest/60 mt-6">
            {mode === "login" ? "New to IAH? " : "Already have an account? "}
            <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="underline text-forest" data-testid="auth-toggle">
              {mode === "login" ? "Create an account" : "Sign in"}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
